<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="https://xylo.codesinn.com/logo-xylo-impact.svg" alt="XYLO" class="mx-auto" width="250">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recover your password</h4>
                  <p>Enter the email address associated with your XYLO account. If a matching account exists, we will send you a reset link valid for 30 minutes.</p>
                </div>

                <vs-input
                  type="email"
                  label-placeholder="Email"
                  v-model="email"
                  v-validate="'required|email'"
                  name="email"
                  :disabled="sent"
                  class="w-full mb-6"
                  @keyup.enter="submit"
                />
                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                <vs-alert v-if="sent" color="success" class="mb-4" :active="true">
                  If that email matches an account, a reset link has been sent. Check your inbox (and the spam folder).
                </vs-alert>

                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row mt-4">
                  <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-4 sm:mb-0">Back to login</vs-button>
                  <vs-button :disabled="!canSubmit" @click="submit" class="w-full sm:w-auto">{{ sent ? 'Resend link' : 'Send reset link' }}</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'

export default {
  data () {
    return {
      email: '',
      sent: false,
      submitting: false
    }
  },
  computed: {
    canSubmit () {
      return !this.submitting && this.email && !this.errors.any()
    }
  },
  methods: {
    async submit () {
      const ok = await this.$validator.validateAll()
      if (!ok || !this.email) return
      this.submitting = true
      this.$vs.loading()
      try {
        await axios.post('/auth/forgot-password', { email: this.email.trim() })
        this.sent = true
      } catch (e) {
        // Endpoint always returns 200 on success; only network errors land here.
        this.$vs.notify({
          title: 'Error',
          text: 'Could not reach the server. Please try again.',
          color: 'danger',
          position: 'bottom-right'
        })
      } finally {
        this.$vs.loading.close()
        this.submitting = false
      }
    }
  }
}
</script>
